import {useQuery} from "react-query";
import TEUByMonthApi from "./TEUByMonth.api";
import { IWidgetQuery } from "../Base/Base.types";

export function useTEUByMonth(query:IWidgetQuery){
    return useQuery(["fetchTEUByMonth", query], TEUByMonthApi.getData);
}